import { payloadActionGenerator } from "@utils/redux";

export const SET_SHOULD_SHOW_PRODUCT_TOURS = "SET_SHOULD_SHOW_PRODUCT_TOURS";
export const SET_IS_ABSOLUTE = "SET_IS_ABSOLUTE";

export const setShouldShowProductTours = payloadActionGenerator(SET_SHOULD_SHOW_PRODUCT_TOURS);
export const setIsAbsolute = payloadActionGenerator(SET_IS_ABSOLUTE);
